import React, { useEffect, useState, Fragment } from 'react';
import { PageHeader } from '../../../Common';
import services from '../services';
import $ from 'jquery';
import authService from '../../Common/services';
import MessageModal from '../../../UI/Modal/MessageModal';
import { LoadingSpinerComponent } from '../../../Common/loader';
import { trackPromise } from 'react-promise-tracker';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Joi from '@hapi/joi';
import { UpdateTemporaryCardValidationSchemaObject } from '../UpdateTemporaryCardValidationSchema';
import { validate } from "../../Common";
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import tokenService from '../../../Common/tokenDecoder';
import { IconButton } from '@material-ui/core';
import { Edit } from '@material-ui/icons';
import { TableEmployeeTaskDetails } from '../../Common/Table/tableContent';
import { create, set } from 'lodash';

const screenCode = 'UPDATETEMPORARYCARDS';

export function UpdateTemporaryCardListing(props) {
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [collectionPoints, setCollectionPoints] = useState([]);
    const [errors, setErrors] = useState({});
    const [mappingArray, setMappingArray] = useState([]);
    const [IDDataForDeduction, setIsIDDataForDeduction] = useState(null);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })
    const [isTableHidden, setIsTableHidden] = useState(true);
    const [isEnable, setIsEnable] = useState(true);
    const [temporaryCardData, setTemporaryCardData] = useState({
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        fromDate: new Date().toISOString().split('T')[0],
    });
    const schema = Joi.object(UpdateTemporaryCardValidationSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        setMultipleEstates([]);
    }, []);

    useEffect(() => {
        if (temporaryCardData.groupID !== '0') {
            trackPromise(getEstatesForDropdown());
        }
    }, [temporaryCardData.groupID]);

    useEffect(() => {
        trackPromise(
            CollectionPointsByOperationEntity()
        )
    }, [temporaryCardData.operationEntityID, temporaryCardData.groupID]);

    useEffect(() => {
        const IDdata = JSON.parse(
            sessionStorage.getItem('temporaryCardData-page-search-parameters-id')
        );
        getPermissions(IDdata);
    }, []);

    useEffect(() => {
        if (IDDataForDeduction !== null) {
            handleSearch();
        }
    }, [IDDataForDeduction]);

    useEffect(() => {
        sessionStorage.removeItem(
            'temporaryCardData-page-search-parameters-id'
        );
    }, [])

    const handleChange = (e) => {
        validateInputs(e.target);
        if (e.target.name === "groupID") {
            setTemporaryCardData({
                ...temporaryCardData,
                [e.target.name]: e.target.value,
                operationEntityID: '0',
                collectionPointID: '0'
            });
            setMultipleEstates([]);
        }
        else if (e.target.name === "operationEntityID") {
            setTemporaryCardData({
                ...temporaryCardData,
                [e.target.name]: e.target.value,
                collectionPointID: '0'
            });
        } else if (e.target.name === "collectionPointID") {
            setTemporaryCardData({
                ...temporaryCardData,
                [e.target.name]: e.target.value
            });
        } else {
            setTemporaryCardData({
                ...temporaryCardData,
                [e.target.name]: e.target.value
            });
        }
        setMappingArray([]);
    };

    function handleFromDateChange(target) {
        const newFromDate = target.value;
        const currentToDate = temporaryCardData.toDate;

        setTemporaryCardData(prevState => ({
            ...prevState,
            fromDate: newFromDate,
            toDate: new Date(currentToDate) < new Date(newFromDate) ? newFromDate : currentToDate
        }));
    }



    function handleClick(item) {
        let model = {
            groupID: parseInt(temporaryCardData.groupID),
            operationEntityID: parseInt(temporaryCardData.operationEntityID),
            collectionPointID: parseInt(temporaryCardData.collectionPointID),
            fromDate: temporaryCardData.fromDate,
        }
        sessionStorage.setItem('temporaryCardData-page-search-parameters-id', JSON.stringify(model));
    }

    async function handleSearch(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        const errorMessages = validate(schema, temporaryCardData);
        if (errorMessages) {
            setErrors(errorMessages);
            return;
        } else {
            setErrors({});
        }
        let model = {
            collectionPointID: parseInt(temporaryCardData.collectionPointID),
            fromDate: temporaryCardData.fromDate
        }
        const response = await services.GetTemporaryCardDetails(model);
        if (response.data.length === 0 || response.data.statusCode === "Error") {
            setMessageModel({ hidden: false, type: "Error", disciption: "No records to display" });
            afterUnsuccessfulyChanged("Error");
            return;
        }

        const mappedData = response.data.map(item => ({
            ...item,
            collectionPointID: temporaryCardData.collectionPointID
        }));

        setMappingArray(mappedData);
        setIsTableHidden(false);
    }

    async function handleUpdate(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        // Find the first updated item (there should only be one)
        const updatedItem = mappingArray.find(
            item =>
                parseInt(item.actualCollectionPointID) !== 0 &&
                parseInt(item.actualCollectionPointID) !== parseInt(item.collectionPointID)
        );

        if (!updatedItem) {
            setMessageModel({
                hidden: false,
                type: "",
                disciption: "No suppliers were updated"
            });
            setTimeout(() => {
                setMessageModel(prev => ({
                    ...prev,
                    hidden: true
                }));
            }, 3000);
            setMappingArray([]);
            setIsTableHidden(true);
            setTemporaryCardData({
                ...temporaryCardData,
                groupID: tokenService.getUserDetailsFromTokenV2().groupID,
                operationEntityID: '0',
                collectionPointID: '0',
                fromDate: new Date().toISOString().split('T')[0],
            });
            return;
        }

        // Prepare the payload as a single object
        const payload = {
            collectionPointID: parseInt(updatedItem.collectionPointID),
            actualCollectionPointID: parseInt(updatedItem.actualCollectionPointID),
            totalKg: Number(updatedItem.totalKg),
            netAmount: Number(updatedItem.netAmount),
            transactionDate: updatedItem.transactionDate,
            createdBy: updatedItem.createdBy,
            createdDate: updatedItem.createdDate,
            modifiedBy: parseInt(tokenService.getUserIDFromToken()),
        };

        // Send a single object, not an array
        const response = await services.UpdateTemporaryCardDetails(payload);

        if (response.statusCode === "Error") {
            setMessageModel({
                hidden: false,
                type: "Error",
                disciption: response.message || "Update failed"
            });
            afterUnsuccessfulyChanged("Error");
            return;
        }

        if (response.statusCode === "Success") {
            setMessageModel({
                hidden: false,
                type: "Success",
                disciption: response.message || "Update successful"
            });
            setTimeout(() => {
                setMessageModel(prev => ({
                    ...prev,
                    hidden: true
                }));
            }, 3000);
            afterUnsuccessfulyChanged("Success");
            setMappingArray([]);
            setIsTableHidden(true);
            setTemporaryCardData({
                ...temporaryCardData,
                groupID: tokenService.getUserDetailsFromTokenV2().groupID,
                operationEntityID: '0',
                collectionPointID: '0',
                fromDate: new Date().toISOString().split('T')[0],
            });
            return;
        }
    }
    function afterUnsuccessfulyChanged(response) {
        if (response === "Error") {
            setTimeout(() => {
                setMessageModel({ hidden: true, type: "Error", disciption: "" });
            }, 4000);
        }
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    async function getPermissions(IDdata) {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWUPDATETEMPORARYCARDS');
        if (!isAuthorized) {
            props.history.push('/unauthorized');
        }

        const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
        const isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode === 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromTokenV2();
        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }
            setMultipleEstates(estateArray)

        }

        setTemporaryCardData({
            ...temporaryCardData,
            groupID: token.groupID,
            operationEntityID: '0',
        });

        trackPromise(
            getAllGroups()
        );
    }

    async function getAllGroups() {
        const data = await groupService.getGroupsForDropdown();
        setGroups(data);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(temporaryCardData.groupID);
        setEstates(data);
    }

    async function CollectionPointsByOperationEntity() {
        let filteredData = await services.getCollectionPointByGroupEntityID(temporaryCardData.operationEntityID);
        setCollectionPoints(filteredData)
    }

    function generateDropDownMenu(data) {
        return Object.entries(data || {}).map(([key, value]) => (
            <MenuItem key={key} value={key}>{value}</MenuItem>
        ));
    }

    function validateInputs(target) {
        const error = { ...errors };
        delete error[target.name];
        setErrors(error);
    }

    const formatDateString = (dateStr) => {
        const date = new Date(dateStr);
        return date.getFullYear() + '-' +
            String(date.getMonth() + 1).padStart(2, '0') + '-' +
            String(date.getDate()).padStart(2, '0');
    };

    const selectedCollectionPoint = (() => {
        const id = temporaryCardData.collectionPointID;
        if (!id || id === '0' || !collectionPoints) return null;
        const name = collectionPoints[String(id)];
        return name ? { id: String(id), name } : null;
    })();

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <form>
                            <PageHeader
                            title="Update Temporary Cards"
                            />
                            <div className="card-body">
                                <div className="form-group row">
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!isEnable || !permissionList.isGroupFilterEnabled}
                                            value={temporaryCardData.groupID}
                                            onChange={handleChange}>

                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!isEnable || !permissionList.isOperationEntityFilterEnabled}
                                            value={temporaryCardData.operationEntityID}
                                            onChange={handleChange}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(
                                                Object.fromEntries(
                                                    Object.entries(estates).filter(([key, value]) => {
                                                        if (key === "0" || !value) return false;
                                                        if (!multipleEstates || Object.keys(multipleEstates).length === 0) {
                                                            return true;
                                                        }
                                                        return Object.values(multipleEstates).includes(value);
                                                    })
                                                )
                                            )}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Supplier *</InputLabel>
                                        <Autocomplete
                                            options={Object.entries(collectionPoints || {}).map(([id, name]) => ({ id: String(id), name }))}
                                            getOptionLabel={(option) => option.name || ''}
                                            value={selectedCollectionPoint}
                                            onChange={(e, newValue) => {
                                                setTemporaryCardData(prev => ({
                                                    ...prev,
                                                    collectionPointID: newValue ? String(newValue.id) : '0'
                                                }));
                                                const newErrors = { ...errors };
                                                delete newErrors.collectionPointID;
                                                setErrors(newErrors);
                                                setMappingArray([]);
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="--Select Supplier--"
                                                    error={!!errors["collectionPointID"]}
                                                    fullWidth
                                                />
                                            )}
                                        />
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-3 pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            value={temporaryCardData.fromDate}
                                            disabled={!isEnable}
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && <FormHelperText error>{errors["fromDate"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md-12">
                                        <input
                                            type="submit"
                                            className="btn btn-primary"
                                            value="Search"
                                            disabled={!isEnable}
                                            onClick={e => trackPromise(handleSearch(e))}
                                        />
                                    </div>
                                </div>
                                {mappingArray.length > 0 && (
                                    <Box display="flex" justifyContent="flex-end" p={2} hidden={isTableHidden}>
                                        <TableContainer component={Paper} style={{ margin: "0 auto" }}>
                                            <Table aria-label="simple table" >
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Supplier Code</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Temporary Supplier Name</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Total Kg</TableCell>
                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Actual Supplier Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {mappingArray.map((row) => (
                                                        <TableRow key={row.factoryWeighCollectionID}>
                                                            <TableCell align="center">{row.collectionPointCode}</TableCell>
                                                            <TableCell align="center">{row.collectionPointName}</TableCell>
                                                            <TableCell align="center">{row.totalKg.toFixed(2)}</TableCell>
                                                            <TableCell align="center">
                                                                <Select
                                                                    value={row.actualCollectionPointID !== undefined && row.actualCollectionPointID !== null ? String(row.actualCollectionPointID) : ""}
                                                                    onChange={e => {
                                                                        // Update mappingArray with the new value for this row
                                                                        setMappingArray(prev =>
                                                                            prev.map(item =>
                                                                                item.factoryWeighCollectionID === row.factoryWeighCollectionID
                                                                                    ? { ...item, actualCollectionPointID: e.target.value }
                                                                                    : item
                                                                            )
                                                                        );
                                                                    }}
                                                                    displayEmpty
                                                                    style={{ minWidth: 120 }}
                                                                >
                                                                    <MenuItem value="0">
                                                                        <em>{row.collectionPointName}</em>
                                                                    </MenuItem>
                                                                    {Object.entries(collectionPoints)
                                                                        .filter(([id]) => id !== String(row.collectionPointID)) // Exclude current collection point
                                                                        .map(([id, name]) => (
                                                                            <MenuItem key={id} value={id}>{name}</MenuItem>
                                                                        ))}
                                                                </Select>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                )}
                            </div>
                            {mappingArray.length > 0 && (
                                <div className="col-md-12">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value="Update"
                                        onClick={handleUpdate}
                                    />
                                </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}
